import { createGlobalStyle, css } from 'styled-components';

import { zIndexes } from '@core/constant';
import { getStaticPathIconFolder } from '@core/media';
import { EColor, EZIndexName, WithThemeProps } from '@core/type';
import { getPaletteHandlers } from '@core/util';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
const pinIcon = getStaticPathIconFolder('google-place/pin.svg') as any;

export const AddressAutocompleteGlobalStyle = createGlobalStyle(
  ({ theme: { palette } }: WithThemeProps) => {
    const { getTextColor, getBackgroundColor, getBoxShadow } = getPaletteHandlers(palette);
    const textColor = getTextColor(EColor.PRIMARY);
    const defaultBoxShadow = getBoxShadow(EColor.ELEVATION_2);

    return css`
      .pac-container {
        margin-top: 2px;
        padding: 24px;
        z-index: ${zIndexes[EZIndexName.MODAL]};
        top: 48px;
        overflow: hidden;
        border: none;
        border-radius: 6px;
        background-color: ${getBackgroundColor({
          semanticType: EColor.NEUTRAL,
          variant: EColor.LIGHT,
        })};
        box-shadow: ${defaultBoxShadow};
        font-size: inherit;
        font-family: inherit;

        &:after {
          content: none;
        }

        .pac-item {
          line-height: 40px;
          padding: 0;
          vertical-align: middle;
          font-size: inherit;
          border: none;
          color: ${textColor};

          &:hover {
            background-color: initial;
          }

          .pac-icon {
            width: 16px;
            height: 16px;
            margin-top: 0;
            margin-right: 32px;
            display: inline-block;
            vertical-align: middle;
            background-image: url(${pinIcon});
            background-size: 16px;
          }

          .pac-icon-marker {
            background-position: center;
          }

          .pac-item-query {
            font-size: inherit;
            padding-right: 6px;
            color: ${textColor};
          }
        }
      }
    `;
  },
);
